import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCardNumber',
})
export class FormatCardNumberPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return '';

    // Convert to string and remove all non-digits just in case
    const digitsOnly = value.toString().replace(/\D/g, '');

    // Group into chunks of 4
    return digitsOnly.replace(/(.{4})/g, '$1 ').trim();
  }
}
